<template>
  <div class="mx-auto">
    <div v-if="isFetchingSession">
      <p>Loading checkout...</p>
    </div>
    <div v-else>
      <!-- add a ref here -->
      <div
        ref="checkoutContainer"
        id="checkout-container"
        class="py-8 bg-white border shadow-lg border-clay-500 rounded-2xl"
      ></div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, defineProps, ref } from 'vue'
import { loadStripe } from '@stripe/stripe-js'
import { trackEvent } from '@/shared'

const props = defineProps({
  stripeKey: String,
  clientSecret: { type: String, default: 'monthly' },
  plan: String,
  open: Boolean
})

const checkoutContainer = ref<HTMLElement | null>(null)
const isFetchingSession = ref(true)
const stripePromise = loadStripe(props.stripeKey)

onMounted(async () => {
  isFetchingSession.value = false
  const stripe = await stripePromise
  if (!stripe || !checkoutContainer.value) return

  // 1) Prepare the observer *before* mount
  const observer = new MutationObserver((mutations, obs) => {
    for (const m of mutations) {
      for (const node of Array.from(m.addedNodes)) {
        if (node instanceof HTMLIFrameElement) {
          node.setAttribute('title', 'Stripe Embedded Checkout')
          obs.disconnect()
          return
        }
      }
    }
  })
  observer.observe(checkoutContainer.value, { childList: true, subtree: true })

  // 2) Mount the embedded checkout
  const checkout = await stripe.initEmbeddedCheckout({
    clientSecret: props.clientSecret
  })
  checkout.mount(checkoutContainer.value)

  // 3) If it was injected synchronously, patch it now
  const immediateFrame = checkoutContainer.value.querySelector<HTMLIFrameElement>('iframe')
  if (immediateFrame) {
    immediateFrame.setAttribute('title', 'Stripe Embedded Checkout')
    observer.disconnect()
  }

  // 4) Analytics
  trackEvent('upgrade_started', { plan: props.plan }, true, false)
})
</script>
